import React from "react";
import TimelineJourneyCard from "./journey/TimelineJourneyCard";
import CycleJourneyCard from "./journey/CycleJourneyCard";

interface JourneyCardProps {
  type: string;
}

const JourneyCard = ({ type }: JourneyCardProps) => {
  if (type === "cycle") {
    return <CycleJourneyCard />;
  }
  return <TimelineJourneyCard />;
};

export default JourneyCard;
